import { render, staticRenderFns } from "./preview_rubric_view.vue?vue&type=template&id=c33b4016&scoped=true&"
import script from "./preview_rubric_view.vue?vue&type=script&lang=js&"
export * from "./preview_rubric_view.vue?vue&type=script&lang=js&"
import style0 from "./preview_rubric_view.vue?vue&type=style&index=0&id=c33b4016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b4016",
  null
  
)

export default component.exports